import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_2 = { class: "el-dropdown-link" }
const _hoisted_3 = { style: {"margin-top":"20px"} }

import { unref, ref, reactive, onMounted, watch } from 'vue';
import { ElButton, ElMessage, ElMessageBox } from 'element-plus';
import { ModuleDialog } from './components/Index';
import { useDictionary } from '@/store/dictionary.store';
import { GetModuleTreesApi, GetModuleChildApi, ModuleDeleteApi } from '@/apis/basics/modules/api';
import { ModuleSearchDto, ModuleTreeListDto } from '../../../apis/basics/modules/dto';
import { useLocales } from '@/hooks/useLocales';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useLocales();
const { getName } = useDictionary();
const moduleDialogRef = ref<ComponentRef<typeof ModuleDialog>>();

const search = reactive<ModuleSearchDto>({
	module_type: undefined,
	module_app: 1,
	is_enabled: '',
	pid: '10000000-0000-0000-0000-000000000001',
	current: 1,
	page_size: 10,
});

const moduleTrees = ref<ModuleTreeListDto[]>([]);
const moduleTotal = ref<number>(0);

const getModuleTrees = async (search: ModuleSearchDto) => {
	const { succeeded, errors, data } = await GetModuleTreesApi(search);
	if (!succeeded) {
		ElMessage.error(errors);
	} else {
		moduleTrees.value = data.data || [];
		moduleTotal.value = data.total || 0;
	}
};

/* 操作按钮 */
const actions = {
	/* 创建(根目录) */
	create: () => {
		unref(moduleDialogRef)?.createRoot();
	},

	/* 新增子模块 */
	addChild: (row: any) => {
		unref(moduleDialogRef)?.creaetChild(row.id);
	},

	/* 编辑 */
	modify: (row: any) => {
		unref(moduleDialogRef)?.modify(row.id);
	},

	/* 删除 */
	delete: async (row: any) => {
		ElMessageBox.confirm(t('basics.modules.confirm.deleteMessage', '是否删除选中的数据？'), t('basics.modules.confirm.deleteTitle', '提示'), { lockScroll: false, confirmButtonText: t('basics.modules.confirm.confirm', '确定'), cancelButtonText: t('basics.modules.confirm.cancel', '取消'), type: 'warning' }).then(async () => {
			const { succeeded, errors } = await ModuleDeleteApi({ id: row.id, revision: row.revision });

			if (!succeeded) {
				ElMessage.error(errors);
			} else {
				ElMessage.success(t('messages.deleteSuccess', '删除成功'));
			}

			getModuleTrees(search);
		});
	},

	/* 刷新数据 */
	refresh: () => {
		search.page_size = 10;
		search.current = 1;
		search.pid = '10000000-0000-0000-0000-000000000001';
		// search.module_app = 1

		getModuleTrees(search);
	},
};

/* 懒加载数据 */
const onLazyLoad = async (row: any, treeNode: unknown, resolve: (data: any[]) => void) => {
	const { succeeded, data } = await GetModuleChildApi(row.id);
	const moduleList = !succeeded ? [] : data || [];

	resolve(moduleList);
};

/* Watch：分页属性改变 */
watch(
	() => search.current,
	() => {
		getModuleTrees(search);
	}
);
watch(
	() => search.page_size,
	() => {
		getModuleTrees(search);
	}
);

onMounted(() => {
	getModuleTrees(search);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(search),
          size: "small",
          inline: true,
          "body-style": { paddingBottom: '0' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              style: {"margin-bottom":"0"},
              "label-width": '80px',
              label: _unref(t)('basics.modules.search.moduleCode', '模块编号')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(search).code,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(search).code) = $event)),
                  placeholder: _unref(t)('basics.modules.search.moduleCode', '请输入模块编号')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              style: {"margin-bottom":"0"},
              "label-width": '80px',
              label: _unref(t)('basics.modules.search.moduleName', '模块名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: _unref(t)('basics.modules.search.moduleName', '请输入模块名称')
                }, null, 8, ["placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      icon: "Search",
                      onClick: actions.refresh
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('basics.modules.search.buttons.search', '查询')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_unref(ElButton), {
                      icon: "Plus",
                      type: "primary",
                      onClick: actions.create
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('basics.modules.search.buttons.createRoot', '创建目录')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          size: "small",
          data: moduleTrees.value,
          style: {"width":"100%","margin-bottom":"20px"},
          "row-key": "id",
          border: "",
          lazy: "",
          load: onLazyLoad,
          "tree-props": { children: 'child', hasChildren: 'has_child' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: _unref(t)('basics.modules.table.moduleName', '模块名称'),
              width: "150",
              "header-align": "center"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "code",
              label: _unref(t)('basics.modules.table.moduleCode', '模块标识'),
              width: "150",
              "header-align": "center"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "path",
              label: _unref(t)('basics.modules.table.routeUrl', '路由URL'),
              width: "200",
              "header-align": "center"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "component_path",
              label: _unref(t)('basics.modules.table.componentUrl', '组件URL'),
              "header-align": "center"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "remark",
              label: _unref(t)('basics.modules.table.remark', '备注'),
              "header-align": "center"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "sort",
              label: _unref(t)('basics.modules.table.sort', '排序'),
              width: "80",
              align: "center"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "module_type",
              width: "80",
              label: _unref(t)('basics.modules.table.moduleType', '模块类型'),
              align: "center"
            }, {
              default: _withCtx((scope) => [
                (scope.row.module_type == 1)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('basics.modules.moduleTypes.directory', '目录')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (scope.row.module_type == 2)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      size: "success"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('basics.modules.moduleTypes.menu', '菜单')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (scope.row.module_type == 3)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 2,
                      size: "warning"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('basics.modules.moduleTypes.button', '按钮')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "module_app",
              width: "100",
              label: _unref(t)('basics.modules.table.moduleApp', '应用场景'),
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_tag, { size: "small" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getName)('module_app', scope.row.module_app)), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "is_enabled",
              width: "80",
              label: _unref(t)('basics.modules.table.status', '状态'),
              align: "center"
            }, {
              default: _withCtx((scope) => [
                (scope.row.is_enabled == 'Y')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "success",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('basics.modules.status.enabled', '启用')), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: "danger",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('basics.modules.status.disabled', '停用')), 1)
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _unref(t)('basics.modules.table.actions', '操作'),
              width: "150",
              align: 'center',
              flex: "right"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_unref(ElButton), {
                    type: "success",
                    link: "",
                    onClick: ($event: any) => (actions.modify(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('basics.modules.actions.edit', '编辑')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_dropdown, {
                    style: {"padding":"2px","margin-left":"12px"},
                    trigger: "click"
                  }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ElButton), {
                                type: "primary",
                                link: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.is_enabled == 'Y' ? _unref(t)('basics.modules.status.disabled', '停用') : _unref(t)('basics.modules.status.enabled', '启用')), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          (scope.row.module_type != 3)
                            ? (_openBlock(), _createBlock(_component_el_dropdown_item, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ElButton), {
                                    type: "info",
                                    link: "",
                                    onClick: ($event: any) => (actions.addChild(scope.row))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('basics.modules.actions.addChild', '添加子模块')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (scope.row.module_type != 3)
                            ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                key: 1,
                                divided: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ElButton), {
                                    type: "danger",
                                    link: "",
                                    onClick: ($event: any) => (actions.delete(scope.row))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('basics.modules.actions.delete', '删除')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('basics.modules.actions.more', '更多')), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_pagination, {
            small: "",
            background: "",
            pageSize: _unref(search).page_size,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((_unref(search).page_size) = $event)),
            currentPage: _unref(search).current,
            "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_unref(search).current) = $event)),
            hideOnSinglePage: false,
            layout: 'sizes, prev, pager, next, jumper, ->, total',
            pageSizes: [10, 20, 30, 40, 50, 100],
            pagerCount: 8,
            total: moduleTotal.value
          }, null, 8, ["pageSize", "currentPage", "total"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(ModuleDialog), {
      ref_key: "moduleDialogRef",
      ref: moduleDialogRef,
      onRefresh: _cache[3] || (_cache[3] = ($event: any) => (getModuleTrees(_unref(search))))
    }, null, 512)
  ], 64))
}
}

})